
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/stories/[initiationId]/timelines",
      function () {
        return require("private-next-pages/stories/[initiationId]/timelines/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/stories/[initiationId]/timelines"])
      });
    }
  